import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgRedo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M12.136 0C7.643 0 4 3.582 4 8s3.643 8 8.136 8c1.871 0 3.587-.63 4.959-1.677l.253-.201-1.44-1.416A6.123 6.123 0 0112.136 14c-3.365 0-6.102-2.692-6.102-6 0-3.309 2.737-6 6.102-6 1.493 0 2.877.508 3.918 1.414l.238.214c.16.146.313.29.405.377L15 5.032 20 8V2l-1.579.961-.54-.598a2.724 2.724 0 00-.083-.086A8.151 8.151 0 0012.136 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Redo')(SvgRedo);
